import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Modal, ContentBlock, ContentItem} from '@ace-de/ui-components';
import {ButtonPrimary, ButtonSecondary} from '@ace-de/ui-components/buttons';
import {Icon, closeIcon} from '@ace-de/ui-components/icons';
import * as memberActionTypes from '../memberActionTypes';

const DeleteMemberNoteConfirmationModal = ({confirmMemberNoteDelete, declineMemberNoteDelete, hasBackdrop}) => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const translateModal = createTranslateShorthand('delete_member_note_confirmation_modal');

    return (
        <Modal
            action={(
                <Icon icon={closeIcon} onClick={declineMemberNoteDelete} />
            )}
            hasBackdrop={hasBackdrop}
            contentClassName={cx('global!ace-u-flex--justify-center')}
        >
            <ContentBlock className={cx([
                'global!ace-u-flex',
                'global!ace-u-flex--direction-column',
                'global!ace-u-flex--justify-center',
                'global!ace-u-flex--align-center',
            ])}
            >
                <ContentItem className={cx([
                    'ace-c-content-item--large-span-11',
                    'global!ace-u-flex',
                    'global!ace-u-flex--align-center',
                    'global!ace-u-flex--direction-column',
                ])}
                >
                    <p
                        className={cx([
                            'global!ace-u-margin--bottom-32',
                            'global!ace-u-typography--align-center',
                        ])}
                    >
                        {translateModal('heading.delete_confirmation')}
                    </p>
                </ContentItem>
                <ContentItem
                    className={cx([
                        'global!ace-u-flex--direction-column',
                        'global!ace-u--margin-0',
                    ])}
                >
                    <ButtonPrimary
                        className={cx(['global!ace-u-margin--bottom-24', 'global!ace-u-full-width'])}
                        onClick={confirmMemberNoteDelete}
                    >
                        {translateModal('button_label.delete_note')}
                    </ButtonPrimary>
                    <ButtonSecondary
                        className={cx('global!ace-u-full-width')}
                        onClick={declineMemberNoteDelete}
                    >
                        {translateModal('button_label.abort')}
                    </ButtonSecondary>
                </ContentItem>
            </ContentBlock>
        </Modal>
    );
};

DeleteMemberNoteConfirmationModal.propTypes = {
    declineMemberNoteDelete: PropTypes.func.isRequired,
    confirmMemberNoteDelete: PropTypes.func.isRequired,
    hasBackdrop: PropTypes.bool,
};

DeleteMemberNoteConfirmationModal.defaultProps = {
    hasBackdrop: true,
};

const mapDispatchToProps = dispatch => ({
    declineMemberNoteDelete: () => dispatch({type: memberActionTypes.DECLINE_MEMBER_NOTE_DELETE}),
    confirmMemberNoteDelete: () => dispatch({type: memberActionTypes.CONFIRM_MEMBER_NOTE_DELETE}),
});

export default connect(null, mapDispatchToProps)(DeleteMemberNoteConfirmationModal);
